import {combineReducers} from 'redux'
import {LINKS_LOADED, COMPANY_LOADED, COMPANY_CONFIGS_LOADED, COMPANY_CONFIGS_QUERIED, COMPANY_STREAM_LOADED, COMPANY_STREAM_QUERIED, MINOR_COMPANY_STREAM_QUERIED, USER_STREAM_LOADED, USER_CONFIGS_LOADED, USER_CONFIGS_QUERIED, AGENCY_STREAM_LOADED, AGENCY_STREAM_QUERIED, AGENCY_LOADED, SUBSIDIARY_STREAM_LOADED, SUBSIDIARY_STREAM_QUERIED, USER_CRITERIA_UPDATED, AGENCY_CRITERIA_UPDATED, COMPANY_CRITERIA_UPDATED, MINOR_COMPANY_CRITERIA_UPDATED, MINOR_COMPANY_CRITERIA_RESET} from './actions'
import {REFERENCE_COMPANY_CMD_UPDATED, REFERENCE_AGENCY_CMD_UPDATED, REFERENCE_USER_CMD_UPDATED, UPDATE_AGENCY_CMD_UPDATED, UPDATE_COMPANY_CMD_UPDATED, IDENTIFY_COMPANY_CMD_UPDATED, UPDATE_USER_CMD_UPDATED, UPDATE_LOGIN_CMD_UPDATED, DOWNGRADE_EXECUTIVE_TO_PATRIMONY_MANAGER_CMD_UPDATED, COMPANY_CONFIGS_UPDATED, USER_CONFIGS_UPDATED} from './actions'
import {REFERENCE_COMPANY_CMD_SENT, REFERENCE_AGENCY_CMD_SENT, REFERENCE_USER_CMD_SENT, UPDATE_AGENCY_CMD_SENT, UPDATE_COMPANY_CMD_SENT, IDENTIFY_COMPANY_CMD_SENT, UPDATE_USER_CMD_SENT, UPDATE_LOGIN_CMD_SENT, DOWNGRADE_EXECUTIVE_TO_PATRIMONY_MANAGER_CMD_SENT} from './actions'

function company(state = null, action) {
    switch (action.type) {
        case COMPANY_LOADED:
            return action.company
        default:
            return state
    }
}

function companyAgencies(state = null, action) {
    switch (action.type) {
      case COMPANY_LOADED:
          return action.companyAgencies
      default:
          return state
    }
}

function companyUsers(state = null, action) {
    switch (action.type) {
      case COMPANY_LOADED:
          return action.companyUsers
      default:
          return state
    }
}

function companySubsidiaries(state = null, action) {
    switch (action.type) {
      case COMPANY_LOADED:
          return action.companySubsidiaries
      default:
          return state
    }
}

function companyConfigs(state = {}, action) {
    switch (action.type) {
        case COMPANY_CONFIGS_LOADED:
        case COMPANY_CONFIGS_QUERIED:
            return action.companyConfigs
        case COMPANY_CONFIGS_UPDATED:
            return {...state, ...action.companyConfigs}
        default:
            return state
    }
}

function stream(state = [], action) {
    switch (action.type) {
        case COMPANY_STREAM_LOADED:
        case COMPANY_STREAM_QUERIED:
            return action.stream
        default:
            return state
    }
}

function range(state = null, action) {
    switch (action.type) {
        case COMPANY_STREAM_LOADED:
        case COMPANY_STREAM_QUERIED:
            return action.range
        default:
            return state
    }
}

function _links(state = [], action) {
    switch (action.type) {
        case COMPANY_STREAM_LOADED:
        case COMPANY_STREAM_QUERIED:
        case LINKS_LOADED:
            return action._links
        default:
            return state
    }
}

function query(state = null, action) {
    switch (action.type) {
        case COMPANY_STREAM_LOADED:
        case COMPANY_STREAM_QUERIED:
            return action.query
        default:
            return state
    }
}

function criteria(state = null, action) {
    switch (action.type) {
        case COMPANY_CRITERIA_UPDATED:
            return {...state, ...action.criteria}
        default:
            return state
    }
}

function minorStream(state = [], action) {
    switch (action.type) {
        case MINOR_COMPANY_STREAM_QUERIED:
            return action.stream
        default:
            return state
    }
}

function minorRange(state = null, action) {
    switch (action.type) {
        case MINOR_COMPANY_STREAM_QUERIED:
            return action.range
        default:
            return state
    }
}

function minorCriteria(state = null, action) {
    switch (action.type) {
        case MINOR_COMPANY_CRITERIA_UPDATED:
            return {...state, ...action.minorCriteria}
        case MINOR_COMPANY_CRITERIA_RESET:
            return null
        default:
            return state
    }
}

function referenceCompanyCmd(state = null, action) {
    switch (action.type) {
        case REFERENCE_COMPANY_CMD_UPDATED:
            return {...state, ...action.cmd}
        case MINOR_COMPANY_STREAM_QUERIED:
            return {...state, callCenterReference: action.stream && action.stream.length > 0 && action.stream[0].uid}
        case REFERENCE_COMPANY_CMD_SENT:
            return null
        default:
            return state
    }
}

function referenceAgencyCmd(state = null, action) {
    switch (action.type) {
        case REFERENCE_AGENCY_CMD_UPDATED:
            return {...state, ...action.cmd}
        case REFERENCE_AGENCY_CMD_SENT:
            return null
        default:
            return state
    }
}

function referenceUserCmd(state = null, action) {
    switch (action.type) {
        case REFERENCE_USER_CMD_UPDATED:
            return {...state, ...action.cmd}
        case REFERENCE_USER_CMD_SENT:
            return null
        default:
            return state
    }
}

function updateAgencyCmd(state = null, action) {
    switch (action.type) {
        case UPDATE_AGENCY_CMD_UPDATED:
            return {...state, ...action.cmd}
        case UPDATE_AGENCY_CMD_SENT:
            return null
        default:
            return state
    }
}

function updateCompanyCmd(state = null, action) {
    switch (action.type) {
        case UPDATE_COMPANY_CMD_UPDATED:
            return {...state, ...action.cmd}
        case UPDATE_COMPANY_CMD_SENT:
            return null
        default:
            return state
    }
}

function identifyCompanyCmd(state = null, action) {
    switch (action.type) {
        case IDENTIFY_COMPANY_CMD_UPDATED:
            return {...state, ...action.cmd}
        case IDENTIFY_COMPANY_CMD_SENT:
            return null
        default:
            return state
    }
}

function updateUserCmd(state = null, action) {
    switch (action.type) {
        case UPDATE_USER_CMD_UPDATED:
            return {...state, ...action.cmd}
        case UPDATE_USER_CMD_SENT:
            return null
        default:
            return state
    }
}

function updateLoginCmd(state = null, action) {
    switch (action.type) {
        case UPDATE_LOGIN_CMD_UPDATED:
            return {...state, ...action.cmd}
        case UPDATE_LOGIN_CMD_SENT:
            return null
        default:
            return state
    }
}

function downgradeExecutiveToPatrimonyManagerCmd(state = null, action) {
    switch (action.type) {
        case DOWNGRADE_EXECUTIVE_TO_PATRIMONY_MANAGER_CMD_UPDATED:
            return {...state, ...action.cmd}
        case DOWNGRADE_EXECUTIVE_TO_PATRIMONY_MANAGER_CMD_SENT:
            return null
        default:
            return state
    }
}

const user = (function() {

    function stream(state = [], action) {
        switch (action.type) {
            case USER_STREAM_LOADED:
                return action.stream
            default:
                return state
        }
    }

    function range(state = null, action) {
        switch (action.type) {
            case USER_STREAM_LOADED:
                return action.range
            default:
                return state
        }
    }

    function query(state = null, action) {
        switch (action.type) {
            case USER_STREAM_LOADED:
                return action.query
            default:
                return state
        }
    }

    function criteria(state = {active: true}, action) {
        switch (action.type) {
            case USER_CRITERIA_UPDATED:
                return {...state, ...action.criteria}
            default:
                return state
        }
    }

    function userConfigs(state = {}, action) {
        switch (action.type) {
            case USER_CONFIGS_LOADED:
            case USER_CONFIGS_QUERIED:
                return action.userConfigs
            case USER_CONFIGS_UPDATED:
                return {...state, ...action.userConfigs}
            default:
                return state
        }
    }

    return combineReducers({stream, range, query, criteria, userConfigs})
})()

const agency = (function() {

    function stream(state = [], action) {
        switch (action.type) {
            case AGENCY_STREAM_LOADED:
            case AGENCY_STREAM_QUERIED:
                return action.stream
            default:
                return state
        }
    }

    function range(state = null, action) {
        switch (action.type) {
            case AGENCY_STREAM_LOADED:
            case AGENCY_STREAM_QUERIED:
                return action.range
            default:
                return state
        }
    }

    function query(state = null, action) {
        switch (action.type) {
            case AGENCY_STREAM_LOADED:
            case AGENCY_STREAM_QUERIED:
                return action.query
            default:
                return state
        }
    }

    function criteria(state = {active: true}, action) {
        switch (action.type) {
            case AGENCY_CRITERIA_UPDATED:
                return {...state, ...action.criteria}
            default:
                return state
        }
    }

    function agency(state = null, action) {
        switch (action.type) {
            case AGENCY_LOADED:
                return action.agency
            default:
                return state
        }
    }

    return combineReducers({stream, range, query, criteria, agency})
})()

const subsidiary = (function() {

    function stream(state = [], action) {
        switch (action.type) {
            case SUBSIDIARY_STREAM_LOADED:
            case SUBSIDIARY_STREAM_QUERIED:
                return action.stream
            default:
                return state
        }
    }

    function range(state = null, action) {
        switch (action.type) {
            case SUBSIDIARY_STREAM_LOADED:
            case SUBSIDIARY_STREAM_QUERIED:
                return action.range
            default:
                return state
        }
    }

    function query(state = null, action) {
        switch (action.type) {
            case SUBSIDIARY_STREAM_LOADED:
            case SUBSIDIARY_STREAM_QUERIED:
                return action.query
            default:
                return state
        }
    }

    return combineReducers({stream, range, query})
})()

export default combineReducers({
    user,
    agency,
    subsidiary,
    company,
    companyAgencies,
    companyUsers,
    companySubsidiaries,
    companyConfigs,
    stream,
    range,
    _links,
    query,
    criteria,
    minorStream,
    minorRange,
    minorCriteria,
    referenceCompanyCmd,
    referenceAgencyCmd,
    referenceUserCmd,
    updateAgencyCmd,
    updateCompanyCmd,
    identifyCompanyCmd,
    updateUserCmd,
    updateLoginCmd,
    downgradeExecutiveToPatrimonyManagerCmd
})


// WEBPACK FOOTER //
// ./lib/company/reducers.js